/* eslint-disable import/prefer-default-export */
export const DOLLIES = 'Dollyt';
